module.exports = __webpack_public_path__ + "group_buy/group_buy_user-8d59b006ee45668fd6f1c73bba7ffbed.svg";